<template>
    <v-row>
        <v-col>
            <v-card>
                <v-card-title>
                    Notice Board
                </v-card-title>
                <v-card-text>
                    <v-btn @click="dlgMarkAttendance.show()" :block="mobile">Mark Attendance</v-btn>

                    <h3 v-if="availableMiqaats.length" class="text-h6 font-weight-bold mt-4 mb-2">Miqaat Registration</h3>

                    <v-alert
                        v-for="miqaat in availableMiqaats"
                        :key="miqaat.miqaatId"
                        type="primary"
                        variant="flat"
                        :icon="false"
                        class="mt-3 text-center miqaat-alert"
                        style="cursor: pointer;"
                        @click="navigateToPage(`miqaat-registration/${miqaat.miqaatId}`)"
                    >
                        <h2>{{ miqaat.miqaatName }}</h2>
                        <div
                            v-if="miqaat.description"
                            class="text-body-1 mt-2"
                            v-html="miqaat.description"
                        />
                        <p class="mt-2 mb-0">
                            Registration:
                            <span class="survey-date">{{ moment(miqaat.registrationStartDate).format("D-MMM-yyyy") }}</span>
                            to
                            <span class="survey-date">{{ moment(miqaat.registrationEndDate).format("D-MMM-yyyy") }}</span>
                        </p>
                        <p v-if="miqaat.existingRegistrationStatus" class="mt-2 mb-0">
                            Status: <strong>{{ formatMiqaatStatus(miqaat.existingRegistrationStatus) }}</strong>
                        </p>
                        <h3 class="mt-2">
                            {{ miqaat.existingRegistrationStatus ? 'View registration / surveys' : 'Click Here To Register' }}
                        </h3>
                    </v-alert>

                    <v-alert
                        v-if="validateIncharges && pendingInchargeCount > 0"
                        type="warning"
                        icon="mdi-account-check"
                        :title="`Miqaat Management (${pendingInchargeCount} pending)`"
                        text="Click here to review and approve registrations from your organization."
                        class="my-2"
                        style="cursor: pointer;"
                        @click="navigateToPage('miqaat-management/incharge')"
                    />

                    <v-alert
                        v-for="survey in availableSurveys"
                        :key="survey.surveyID"
                        variant="outlined"
                        :icon="false"
                        class="mt-3 text-center survey-alert"
                        style="cursor: pointer;"
                        @click="navigateToPage(`survey-forms/${survey.surveyID}`)"
                    >
                        <h2>{{ survey.title }}</h2>
                        <div
                            v-if="survey.description"
                            class="text-body-1 mt-2"
                            v-html="survey.description"
                        />
                        <p class="mt-2 mb-0">
                            <span class="survey-date">{{ moment(survey.startDate).format("D-MMM-yyyy") }}</span>
                            to
                            <span class="survey-date">{{ moment(survey.endDate).format("D-MMM-yyyy") }}</span>
                        </p>
                        <h3 class="mt-2">Click Here To View</h3>
                    </v-alert>

                    <!-- <v-card class="mt-3 text-center" @click="navigateToPage('survey-forms/16')" color="green">
                        <v-card-text>
                            <h2>Asbaaq, Umoor & Professional Survey 1447H</h2><br/>
                            <h3>All Officers & Members are required to fill this form. All are requested to consider this Important & Urgent.</h3><br/>
                            <h3>For any issues or queries contact on Whatsapp:<br/><a href="https://wa.me/+923232199727" target="_blank">Click To Message</a></h3><br/>
                            <h3>Click Here To View</h3>
                        </v-card-text>
                    </v-card> -->

                    <!--<v-card class="mt-3 text-center" @click="navigateToPage('survey-forms/15')" color="green">
                        <v-card-text>
                            <h3>Skill Development and Short Courses for Career Development (Upto 100% Scholarships available for Bright Students)</h3>
                            <h2>All officers/members between ages <span style="font-weight: bold; text-transform: uppercase;">18-25</span> years or children of members between the given age should fill this form</h2>
                            <h3>Click Here To View</h3>
                        </v-card-text>
                    </v-card>-->

                    <!-- <v-card class="mt-3 text-center" @click="navigateToPage('survey-forms/14')" color="green">
                        <v-card-text>
                            <h3>ASHARA MUBARAKA 1447H - RELAY CENTRES</h3>
                            <h2>This is ONLY for officers/members registered for khidmat in Ashara Mubaraka 1447H Relay Centres</h2>
                            <h3>Click Here To View</h3>
                        </v-card-text>
                    </v-card> -->

                    <!-- <v-card class="mt-3 text-center" color="green" @click="navigateToPage('data-update')">
                        <v-card-text>
                            <h2>DATA UPDATE DRIVE</h2>
                            <h3 class="mt-2">Your updated data will help us serve you better</h3>
                            <h3 class="mt-2">Click Here To View</h3>
                        </v-card-text>
                    </v-card> -->

                    <!-- <v-card class="mt-3 text-center" @click="navigateToPage('survey-forms/13')" color="green">
                        <v-card-text>
                            <h3>ASHARA MUBARAKA 1447H</h3>
                            <h2>Khidmat niyyat registration form for INTERNATIONAL ASHARA MUBARAKA ONLY (NOT IN PAKISTAN)</h2>
                            <h3>Click Here To View</h3>
                        </v-card-text>
                    </v-card> -->

                    <!-- <v-card class="mt-3 text-center" @click="navigateToPage('video-library/1')" color="blue">
                        <v-card-text>
                            <h3>BGI Important Paighaam - 1446H Surat</h3>
                            <h3>Click Here To View</h3>
                        </v-card-text>
                    </v-card> -->

                    <!-- <v-card class="mt-3 text-center" style="cursor: pointer;" @click="navigateToPage('tabudaat-forms/2')">
                        <v-card-text>
                            <v-img :src="require(`@/assets/TabudaatAraz.jpg`)" v-if="mobile" />
                            <v-img :src="require(`@/assets/TabudaatAraz.jpg`)" v-else height="200px" />
                            <h3>Click here to submit details</h3>
                        </v-card-text>
                    </v-card> -->

                    <!-- <v-alert type="info" icon="mdi-information" title="Ashara Mubarakah 1446H - Khidmat Survey"
                        text="Click here to view Survey form." class="my-2" @click="navigateToPage('survey-forms/9')"
                        style="cursor: pointer;" /> -->

                    <!-- <v-alert type="info" icon="mdi-information" v-if="validateIncharges || validateAuthOfficers"
                        title="Divisions Inventory Survey" text="Click here to view Survey form." class="my-2"
                        @click="navigateToPage('survey-forms/5')" style="cursor: pointer;" />

                    <v-alert type="info" v-if="validateAuthOfficers || miqaatProcRights" icon="mdi-information"
                        title="Ashara Mubaraka 1446H Procurement Requirements" text="Click here to view the form."
                        class="my-2" @click="navigateToPage('miqaat/procurement-form')" /> -->

                    <!-- <v-alert type="info" icon="mdi-information"
                        title="Ashara Mubarakah 1446H" text="Click here to view Survey form." class="my-2"
                        @click="navigateToPage('survey-forms/8')" style="cursor: pointer;" /> -->
                    <!-- <v-alert type="info" icon="mdi-information"
                        title="Imaani School Survey" text="Click here to view Survey form." class="my-2"
                        @click="navigateToPage('survey-forms/7')" style="cursor: pointer;" /> -->
                    <!-- <v-alert type="info" v-if="validateAuthOfficers" icon="mdi-information" title="FMB Thali Survey Form" text="Click here to view FMB Survey form." class="my-2" @click="navigateToPage('survey-forms/4')" /> -->
                    <!-- <v-alert type="info" icon="mdi-information" title="Al-Istifada Al-Ilmiyah 1445H Survey Form" text="Click here to view Al-Istifada Al-Ilmiyah 1445H survey form." class="my-2" @click="navigateToPage('survey-forms/1')" />
                    <v-alert type="info" icon="mdi-information" title="Ashara Mubarakah 1446H Registration Form" text="Click here to view Ashara 1446H registration form." class="my-2" @click="navigateToPage('survey-forms/2')" /> -->
                    <!-- <v-alert type="info" v-if="validateAuthOfficers" icon="mdi-information" title="Upliftment Form" text="Click here to view member upliftment form." class="my-2" @click="navigateToPage('upliftment-form')" /> -->

                    <!-- <v-alert type="info" icon="mdi-information" title="Attendance Event" text="Click here to view attendance event for Urs Raat Syedna Mohammad Burhanuddin (RA)." class="my-2" @click="navigateToPage(`attendance/7565`)" /> -->
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <v-row v-if="validateAuthOfficers">
        <v-col md="4" cols="12">
            <v-card>
                <v-card-title>
                    Transfer Requests
                </v-card-title>
                <v-card-text>
                    <TransferApprovalView />
                </v-card-text>
            </v-card>
        </v-col>
        <v-col md="4" cols="12">
            <v-card>
                <v-card-title>
                    Status Requests
                </v-card-title>
                <v-card-text>
                    <StatusApprovalView />
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <simple-dialog ref="dlgMarkAttendance" title="Mark Attendance" width="100vw" :hideConfirmButton="true"
        cancelButtonText="Close">
        <template v-slot:content>
            <qr-code-scanner-view @scanned="scanned" />
        </template>
    </simple-dialog>
</template>

<script setup>
import { ref, computed, inject, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from "@/setup/stores/authStore";
import QrCodeScannerView from './Attendance/QrCodeScannerView.vue';
import TransferApprovalView from './Dashboard/TransferApprovalView.vue';
import StatusApprovalView from './Dashboard/StatusApprovalView.vue';
import { useDisplay } from 'vuetify'
import { getAvailable as getAvailableMiqaats, getPendingInchargeCount } from '@/services/miqaatService';
import { getAvailable } from '@/services/surveyService';
import moment from 'moment';

const { mobile } = useDisplay();
const authStore = useAuthStore();
const router = useRouter();

const loader = inject("loader");
// const snackbar = inject("snackBar");

const authOfficers = ref([
    40496719,
    40476109,
    40419031,
    40480238,
    40452802,
    40480239,
    40496185,
    40463461,
]);

// const seniors = ref([
//     20342202,
//     20366455,
//     20366469,
//     20366494,
//     20368891,
//     20370588,
//     20370602,
//     20370615,
//     20377600,
//     20377698,
//     20380601,
//     20380757,
//     20381019,
//     20381629,
//     20383454,
//     20388069,
//     20388272,
//     20388930,
//     40418380,
//     40430737,
//     40434626,
//     40445426,
//     40447099,
//     40461511,
//     40463739,
//     40480917,
//     40485008,
//     40489014,
//     40498124,
//     40498164,
//     40498487,
//     50488538
// ]);

const dlgMarkAttendance = ref(null);
const availableSurveys = ref([]);
const availableMiqaats = ref([]);
const pendingInchargeCount = ref(0);

const validateAuthOfficers = computed(() => {
    if (!!authStore.user && !!authStore.user.itsId)
        return authStore.isSuperAdmin || authOfficers.value.includes(authStore.user.itsId);
    else
        return false;
});

// const validateSeniors = computed(() => {
//     if (!!authStore.user && !!authStore.user.itsId)
//         return seniors.value.includes(authStore.user.itsId);
//     else
//         return false;
// });

// eslint-disable-next-line
const validateIncharges = computed(() => {
    if (authStore.user)
        return authStore.user.isIncharge;
    else
        return false;
});

// eslint-disable-next-line
function navigateToPage(page) {
    router.push(page)
}

function formatMiqaatStatus(status) {
    const map = {
        PendingIncharge: "Pending Incharge Approval",
        PendingCentral: "Pending Central Approval",
        Approved: "Approved",
        Rejected: "Rejected",
    };
    return map[status] || status;
}

function scanned() {
    dlgMarkAttendance.value.hide();
}

onMounted(async () => {

    loader.show();

    var promises = [
        getAvailableMiqaats().catch(() => []),
        getAvailable().catch(() => []),
    ];

    if (validateIncharges.value) {
        promises.push(getPendingInchargeCount().catch(() => 0));
    }

    const results = await Promise.all(promises);

    availableMiqaats.value = results[0] || [];
    availableSurveys.value = results[1] || [];

    if (validateIncharges.value) {
        pendingInchargeCount.value = results[2] || 0;
    }

    loader.hide();

});
</script>

<style scoped>
.miqaat-alert,
.miqaat-alert :deep(.v-alert__content) {
    color: #fff;
}

.miqaat-alert .survey-date {
    color: #fff;
}

.survey-alert {
    color: #000;
}

.survey-alert :deep(.v-alert__content) {
    color: #000;
}

.survey-date {
    font-size: 1.1rem;
    color: red;
    text-decoration: underline;
    font-weight: 600;
}
</style>